import { Brand, PrizetImageAPI } from '../../interface/interface';
import { componentTypes, Schema } from '@data-driven-forms/react-form-renderer';
import { GridProps } from '@mui/system';

export interface ProductSchemaData {
  onChanged?: (e, propertyName: string) => void,
  slug?: string,
  productName: string,
  productDescription: string,
  brandId: string,
  published: boolean,
  images: PrizetImageAPI[],
  tags: any[],
  tagValues: any[],
  attributeValues: any[],
  brands: any[],
  attribute: any[],
  brand?: any,
  editData?: any,

}

export const ProductSchema  = (props: ProductSchemaData) => {
  const {
    tags,
    brands,
    attribute,
    editData,
  } = props;
  return {
    fields: [


      {
        component: componentTypes.TEXT_FIELD,
        dataType: 'string',
        disabled  : true,
        name: 'slug',
        placeholder: 'Slug',
        FormFieldGridProps: { xs: 5.8 },
        initialValue: editData?.slug,
        resolveProps: (props, {}, formOptions) => ({
          value: formOptions.getState().values?.productName?.replace(/\s+/g, '-').toLowerCase(),
        })

      }, // create field for productName{
      {
        component: componentTypes.TEXT_FIELD,
        dataType: 'string',
        disabled: false,
        FormFieldGridProps: { xs: 5.8 },
        label: 'Products Name',
        placeholder: 'Products Name',
        name: 'productName',
        initialValue: editData?.productName,

      },
      {
        component: componentTypes.TEXTAREA,
        dataType: 'string',

        label: 'Products Description',
        placeholder: 'Products Description',
        name: 'productDescription',
        initialValue: editData?.productDescription,
        multiline: true,
        rows: 4

      },
      {
        component: componentTypes.SELECT,

        label: 'Select Brand',
        name: 'brandId',
        options: brands.map((brand: Brand) => ({
          label: brand.label,
          value: brand.value
        })),
        initialValue: editData?.brand?.id,
        resolveProps: (props, { meta,input }, formOptions) => ({
          value: formOptions.getState().values?.brandId,
        }),

      },
      {
        component: componentTypes.CHECKBOX,
        dataType: 'boolean',

        label: 'Published ',
        placeholder: 'is Published',
        name: 'published',
        FormFieldGridProps: { xs: 6 },
        initialValue: editData?.published,
      },
      {
        component: 's3',
        dataType: 'string',
        validate: [
          {
            type: 'required',
            message: 'Image is required'
          }
        ],
        name: 'images',
        FormFieldGridProps: { xs: 6 },
        initialValue: editData?.galleries,
        onS3UploadCallback: (payload: PrizetImageAPI[]) => {

        },

      },
      {
        component: 'tags',
        options: tags.map((tag: {tagName: string, id: string}) => ({
          label: tag.tagName,
          value: tag.id
        })),
        placeholder: 'Tags',
        FormFieldGridProps: { xs: 12 },
        name: 'tags',
        initialValue: editData?.tags?.map((tag: any) => ({
          label: tag.tagName,
          value: tag.id
        })),

      },
      {
        component: 'selector',
        label: 'Select an Attribute',
        dataType: 'string',
        name: 'attributes',
        options: attribute,
        initialValue: editData?.productAttributes,
        FormFieldGridProps: { xs: 12 },
        onAttributeEvent: (values: any) => {

        }
      }
    ]
  } as Schema extends GridProps ? GridProps : never;
};
